"use client";
import { styles } from "./styles";
import { Box } from "@ecco/ui/box";
import { Flex } from "@ecco/ui/flex";
import { IconButton } from "@ecco/ui/icon-button";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { isECCOIconName } from "@ecco/ui/icon-names";
import { isEmpty } from "lodash-es";
import type { FC } from "react";
import { ContentLink } from "@components/cms/link/ContentLink";
import type { FooterLink } from "@lib/contentful/mappers/mapFooter";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";
import { space } from "@ecco/ui/tokens";

interface ISocialMediaWidgetProps {
    socialLinks: FooterLink[];
}

const SocialMediaWidget: FC<ISocialMediaWidgetProps> = ({ socialLinks }) => {
    const { get: getMicrocopy } = useMicrocopy();
    if (isEmpty(socialLinks)) return null;
    return (
        <Box sx={styles.container}>
            <p>{getMicrocopy(CommonCMS.shared, CommonCMS.followUs)}</p>
            <Flex mt={3} gap={space["2"]}>
                {socialLinks?.map((socialLink) => {
                    const icon = socialLink.contentLink.label.toLowerCase();
                    return (
                        <ContentLink
                            key={socialLink.id}
                            link={socialLink.contentLink}
                            aria-label={socialLink.contentLink.label}
                        >
                            <IconButton
                                as="span"
                                aria-hidden="true"
                                aria-label={socialLink.contentLink.label}
                                tabIndex={-1}
                                color="black"
                                bg="transparent"
                                icon={isECCOIconName(icon) ? <ECCOIcon name={icon} /> : undefined}
                                size="mb"
                            />
                        </ContentLink>
                    );
                })}
            </Flex>
        </Box>
    );
};

export default SocialMediaWidget;
